export const getCommonDataRequest = (item) => ({
    type:"GET_COMMON_DATA_REQUEST",
    item
})

export const getStockListSuccess = data => ({
    type:"GET_STOCK_LIST_SUCCESS",
    data
})

export const setTransactionConfigData = data => ({
    type:"SET_TRANSACTION_CONFIG_DATA",
    data
})
